module.exports = __webpack_public_path__ + "img/icon3.f0b51cc7.png";